<div class="spinner-container" *ngIf="isLoading" data-cy="insurance-profile-loading">
  <mat-spinner data-cy="insurance-profile-spinner"></mat-spinner>
</div>
<div data-cy="insurance-profile-container">

  <h5 style="background-color: #00B5FB; height: 28px" data-cy="insurance-profile-title">Edit Insurance Profile Information</h5>

  <div style="width: 100%; padding: 10px" *ngIf="isError" data-cy="insurance-profile-error">
    <br/>
    The insurance company has no claim billing address !!!

  </div>

  <div style="width: 100%; padding: 10px" *ngIf="!isError" data-cy="insurance-profile-content">

    <table class="table-layout" data-cy="insurance-profile-table">
      <tr data-cy="insurance-profile-name-row">
        <td class="table-col-label" data-cy="insurance-profile-name-label">Profile Name:</td>
        <td class="table-col-content" data-cy="insurance-profile-name-value">{{Profile}}</td>
      </tr>
      <tr data-cy="insurance-profile-company-row">
        <td class="table-col-label" data-cy="insurance-profile-company-label">Insurance Company:</td>
        <td class="table-col-content" data-cy="insurance-profile-company-value">{{ProfileOrganization}}</td>
      </tr>
      <tr data-cy="insurance-profile-address-row">
        <td class="table-col-label" data-cy="insurance-profile-address-label">Address:</td>
        <td class="table-col-content" data-cy="insurance-profile-address-value">
          {{Address1}}
          {{Address2}}
          {{Address3}}<br/>
          {{City}}, {{State}} {{PostCode}}<br/>
        </td>
      </tr>

      <tr data-cy="insurance-profile-employer-row">
        <td class="table-col-label" data-cy="insurance-profile-employer-label">Employer:</td>
        <td class="table-col-content" data-cy="insurance-profile-employer-field">
<!--          {{EmployerNO}}-->
          <dx-text-box [(value)]="EmployerNO" data-cy="insurance-profile-employer-input"></dx-text-box>
        </td>
      </tr>
      <tr data-cy="insurance-profile-group-row">
        <td class="table-col-label" data-cy="insurance-profile-group-label">Group:</td>
        <td class="table-col-content" data-cy="insurance-profile-group-field">
<!--          {{GroupNO}}-->
          <dx-text-box [(value)]="GroupNO" data-cy="insurance-profile-group-input"></dx-text-box>
        </td>
      </tr>
      <tr data-cy="insurance-profile-fee-row">
        <td class="table-col-label" data-cy="insurance-profile-fee-label">Fee Schedule:</td>
        <td class="table-col-content" data-cy="insurance-profile-fee-value">{{FeeScheduleName}}</td>
        <td class="table-col-content-action" data-cy="insurance-profile-fee-action"><button class="tdo-button tdo-save" (click)="onChangeFeeSched()" data-cy="insurance-profile-fee-change">Change</button></td>
      </tr>



      <tr data-cy="insurance-profile-payer-row">
        <td class="table-col-label" data-cy="insurance-profile-payer-label"> Payer (NEIC):</td>
        <td class="table-col-content" data-cy="insurance-profile-payer-value">{{PayerIDperNEIC}}</td>
        <td class="table-col-content-action" data-cy="insurance-profile-payer-action"><button class="tdo-button tdo-save" (click)="onChangePayerID()" data-cy="insurance-profile-payer-change">Change</button></td>
      </tr>
      <tr data-cy="insurance-profile-payer-org-row">
        <td class="table-col-label" data-cy="insurance-profile-payer-org-label"> </td>
        <td class="table-col-content" data-cy="insurance-profile-payer-org-value">{{PayerOrganization}}</td>
      </tr>

    </table>

    <div class="action-container" data-cy="insurance-profile-actions">
      <button class="tdo-button tdo-save" style="margin-right: 5px;"
              (click)="save()"
              data-cy="insurance-profile-save">Save</button>
      <button
              class="tdo-button tdo-save"
              (click)="close()" 
              data-cy="insurance-profile-cancel">Cancel</button>
    </div>

  </div>


</div>
